"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var SessionManager = /** @class */ (function () {
    function SessionManager(storage, browser) {
        this.storage = storage;
        this.session = storage.get('currentSession');
        this.browser = browser;
        this.initSession();
    }
    SessionManager.prototype.initSession = function () {
        if (this.session === null)
            this.resetSession();
        if (this.sessionHasExpired())
            this.resetSession();
        this.saveCurrentPath(this.browser.currentPathname);
    };
    SessionManager.prototype.resetSession = function () {
        this.session = {
            browseAbandonmentSent: false,
            date: new Date(),
            pageViewCounter: 0,
            pagesVisited: [],
            renderedCampaigns: [],
            kryptonite: false // This flag is used to render the HE pixel only once
        };
        this.saveSession();
    };
    Object.defineProperty(SessionManager.prototype, "currentSession", {
        get: function () {
            return this.session;
        },
        enumerable: false,
        configurable: true
    });
    SessionManager.prototype.addCampaignRendering = function (campaignID) {
        var campaignHasNotBeenRendered = this.session.renderedCampaigns.find(function (cid) { return cid === campaignID; }) === undefined;
        if (campaignHasNotBeenRendered) {
            this.session.renderedCampaigns.push(campaignID);
            this.saveSession();
        }
    };
    SessionManager.prototype.markKryptoniteAsRendered = function () {
        this.session.kryptonite = true;
        this.saveSession();
    };
    SessionManager.prototype.saveCurrentPath = function (path) {
        this.session.pageViewCounter++;
        this.session.pagesVisited.push(path);
        this.saveSession();
    };
    SessionManager.prototype.saveContactSubscription = function (subscription) {
        var subscriptionStatusIsValid = ['subscribed', 'unsubscribed'].includes(subscription.status);
        var lastUpdated = new Date(subscription.lastUpdated);
        var lastUpdatedIsValid = !Number.isNaN(lastUpdated.valueOf());
        if (!subscriptionStatusIsValid || !lastUpdatedIsValid)
            return;
        this.session.subscription = {
            status: subscription.status,
            lastUpdated: lastUpdated
        };
        this.saveSession();
    };
    SessionManager.prototype.sessionHasExpired = function () {
        var sessionEnd = new Date();
        sessionEnd.setTime(sessionEnd.getTime() - constants_1.SESSION_DURATION);
        return new Date(this.session.date) < sessionEnd;
    };
    SessionManager.prototype.updateBrowseAbandonmentSent = function (sent) {
        this.session.browseAbandonmentSent = Boolean(sent);
        this.saveSession();
    };
    SessionManager.prototype.saveSession = function () {
        this.storage.set('currentSession', this.session);
    };
    return SessionManager;
}());
exports.default = SessionManager;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2Vzc2lvbk1hbmFnZXIuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy9lbnZpcm9ubWVudC9TZXNzaW9uTWFuYWdlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLGdEQUFxRDtBQUlyRDtJQUtJLHdCQUFZLE9BQXFCLEVBQUUsT0FBMkI7UUFDMUQsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7UUFDdEIsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFZLENBQUE7UUFDdkQsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7UUFDdEIsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFRCxvQ0FBVyxHQUFYO1FBQ0ksSUFBSSxJQUFJLENBQUMsT0FBTyxLQUFLLElBQUk7WUFBRSxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUE7UUFDOUMsSUFBSSxJQUFJLENBQUMsaUJBQWlCLEVBQUU7WUFBRSxJQUFJLENBQUMsWUFBWSxFQUFFLENBQUE7UUFFakQsSUFBSSxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxDQUFBO0lBQ3RELENBQUM7SUFFRCxxQ0FBWSxHQUFaO1FBQ0ksSUFBSSxDQUFDLE9BQU8sR0FBRztZQUNYLHFCQUFxQixFQUFFLEtBQUs7WUFDNUIsSUFBSSxFQUFFLElBQUksSUFBSSxFQUFFO1lBQ2hCLGVBQWUsRUFBRSxDQUFDO1lBQ2xCLFlBQVksRUFBRSxFQUFFO1lBQ2hCLGlCQUFpQixFQUFFLEVBQUU7WUFDckIsVUFBVSxFQUFFLEtBQUssQ0FBQyxxREFBcUQ7U0FDMUUsQ0FBQTtRQUVELElBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQTtJQUN0QixDQUFDO0lBRUQsc0JBQUksMENBQWM7YUFBbEI7WUFDSSxPQUFPLElBQUksQ0FBQyxPQUFPLENBQUE7UUFDdkIsQ0FBQzs7O09BQUE7SUFFRCw2Q0FBb0IsR0FBcEIsVUFBcUIsVUFBa0I7UUFDbkMsSUFBTSwwQkFBMEIsR0FDNUIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsVUFBQyxHQUFHLElBQUssT0FBQSxHQUFHLEtBQUssVUFBVSxFQUFsQixDQUFrQixDQUFDLEtBQUssU0FBUyxDQUFBO1FBRWxGLElBQUksMEJBQTBCLEVBQUU7WUFDNUIsSUFBSSxDQUFDLE9BQU8sQ0FBQyxpQkFBaUIsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUE7WUFDL0MsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO1NBQ3JCO0lBQ0wsQ0FBQztJQUVELGlEQUF3QixHQUF4QjtRQUNJLElBQUksQ0FBQyxPQUFPLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQTtRQUM5QixJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDdEIsQ0FBQztJQUVELHdDQUFlLEdBQWYsVUFBZ0IsSUFBWTtRQUN4QixJQUFJLENBQUMsT0FBTyxDQUFDLGVBQWUsRUFBRSxDQUFBO1FBQzlCLElBQUksQ0FBQyxPQUFPLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQTtRQUNwQyxJQUFJLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDdEIsQ0FBQztJQUVELGdEQUF1QixHQUF2QixVQUF3QixZQUFxRDtRQUN6RSxJQUFNLHlCQUF5QixHQUFHLENBQUMsWUFBWSxFQUFFLGNBQWMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLENBQUE7UUFDOUYsSUFBTSxXQUFXLEdBQUcsSUFBSSxJQUFJLENBQUMsWUFBWSxDQUFDLFdBQVcsQ0FBQyxDQUFBO1FBQ3RELElBQU0sa0JBQWtCLEdBQUcsQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxPQUFPLEVBQUUsQ0FBQyxDQUFBO1FBQy9ELElBQUksQ0FBQyx5QkFBeUIsSUFBSSxDQUFDLGtCQUFrQjtZQUFFLE9BQU07UUFDN0QsSUFBSSxDQUFDLE9BQU8sQ0FBQyxZQUFZLEdBQUc7WUFDeEIsTUFBTSxFQUFFLFlBQVksQ0FBQyxNQUF1QztZQUM1RCxXQUFXLEVBQUUsV0FBVztTQUMzQixDQUFBO1FBQ0QsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFRCwwQ0FBaUIsR0FBakI7UUFDSSxJQUFNLFVBQVUsR0FBRyxJQUFJLElBQUksRUFBRSxDQUFBO1FBQzdCLFVBQVUsQ0FBQyxPQUFPLENBQUMsVUFBVSxDQUFDLE9BQU8sRUFBRSxHQUFHLDRCQUFnQixDQUFDLENBQUE7UUFDM0QsT0FBTyxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxHQUFHLFVBQVUsQ0FBQTtJQUNuRCxDQUFDO0lBRUQsb0RBQTJCLEdBQTNCLFVBQTRCLElBQWE7UUFDckMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxxQkFBcUIsR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUE7UUFDbEQsSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFBO0lBQ3RCLENBQUM7SUFFTyxvQ0FBVyxHQUFuQjtRQUNJLElBQUksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLGdCQUFnQixFQUFFLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtJQUNwRCxDQUFDO0lBQ0wscUJBQUM7QUFBRCxDQUFDLEFBbkZELElBbUZDIn0=